import TitlePage from '../../../components/layout/Page/TitlePage';
import React from 'react';
import { useSnackbar } from 'notistack';
import { initialValuesDocument, initialValuesEditDocument } from './types';
import HttpService from '../../../services/HttpService';
import { eliminateOjectNotTruthyValues, isSubmitEnabled } from '../../../lib/helperFuncs';
import RegistrationStepComponent from './RegistrationStepComponent';
import { editDocumentionValidation, newDocumentValidation } from './validationSchema';
import AsyncBackdropSubmit from '../../../components/AsyncBackdropSubmit';
import ContinueProcess from './ContinueProcess';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PreviewTekmrio from '../Tekmirio/PreviewTekmrio';
import { fetchOAtypeFormat, fetchTekmirioTypesOptions, getDocument } from '../../../lib/fetchers';
import FormSkeleton from '../../../components/Skeletons/FormSkeleton';
import DialogAction from '../../../components/Dialog/DialogAction';
import { Divider, Button } from '@mui/material';
import { Form, Formik } from 'formik';
import FormStepperBuilder from '../../../components/form_v2/highLevelComponents/FormStepperBuilder';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import { createDocumentFields, insertDocumentFields } from '../Tekmirio/static';

export const buildFilesRequest = (images: File[], files: File[]) => {
  const formData = new FormData();    
  if (images) {
    images.map((image: File) => {
      if (typeof image !== 'string') {
        formData.append('images',
          new Blob(
            [image],
            { type: image.type }
          ),
          encodeURI(image.name)
        );
      }
    });
  }
  if (files) {
    files.map((x: File) => {
      if (typeof x !== 'string') {
        formData.append('attachments',
          new Blob([x], {
            type: x.type
          }),
          encodeURI(x.name)
        );
      }
    });
  }
  return formData;

};

const RegistrationDocument = () => {
  document.title = 'Εκκίνηση Τεκμηρίου';

  const { enqueueSnackbar } = useSnackbar();
  const [organisations, setOrganisations] = React.useState<any[]>([]);
  const [collections, setCollections] = React.useState<any[]>([]);
  const [typeOptions, setTypeOptions] = React.useState<any[]>([]);
  const [formatOptions, setFormatOptions] = React.useState<any[]>([]);
  const [selectedForeas, setSelectedForeas] = React.useState<string>();
  const [openBackdrop, setOpenBackdrop] = React.useState<boolean>(false);
  const [omekaResponse, setOmekaResponse] = React.useState<any>({});
  const [renderPreview, setRenderPreview] = React.useState(false);
  const [isLoadingDocument, setIsLoadingDocument] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [erga, setErga] = React.useState([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const onSubmit = async (values: any) => {
    try {
      setOpenBackdrop(true);
      const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/tekmirio`, 
        eliminateOjectNotTruthyValues({
          ...values,
          collection_id: collections.find(collection => collection.value === values['collectionsUniqueCode'])['collection_id']
        })
      );
      setOmekaResponse(response.data);
      localStorage.setItem('documentId', response.data.id.toString());
      enqueueSnackbar('Η εκκίνηση καταχώρισης Τεκμηρίου πραγματοποιήθηκε επιτυχώς', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Η εκκίνηση καταχώρισης Τεκμηρίου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    } 
    setOpenBackdrop(false);
  };

  const onSubmitEdit = async (values: any) => {
    setOpenBackdrop(true);
    try {
      const x = collections.find(collection => collection.key === values['documentsRelationCollection'])['collection_id'];
      await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/tekmirio/${omekaResponse.id}`, 
        eliminateOjectNotTruthyValues({
          ...values,
          id: Number(values.id),
          documentsUniqueCode: Number(values.documentsUniqueCode),
          documentsID: Number(values.documentsID),
          documentsAttachedMediaImages: [],
          documentsAttachedMediaFiles: [],
          documentsRelationCollection: [{ key: x, value: x}],
          documentsRelationProject: [{ 
            key: values.documentsRelationProject, 
            value: values.documentsRelationProject
          }]
        })
      );
      if (values?.documentsAttachedMediaImages || values?.documentsAttachedMediaFiles) {
        const document_formData = buildFilesRequest(
          values?.documentsAttachedMediaImages,
          values?.documentsAttachedMediaFiles,
        );
        await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/tekmirio/files/${omekaResponse.id}`, document_formData);
      }
      
      enqueueSnackbar('H καταχώριση Τεκμηρίου υποβλήθηκε επιτυχώς', { variant: 'success' });
      navigate('/admin/document/dashboard');
      localStorage.removeItem('documentId');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('H καταχώριση Τεκμηρίου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    } 
    setOpenBackdrop(false);
  };

  const getOrganisations = async () => {
    try {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/foreas`);
      const organisationResults = resp.data?.data?.map((x: any) => {
        return {
          key: x['organisations:orgIdentifierCountryId'][0]?.['@value'], 
          value: x['organisations:orgIdentifierCountryId'][0]?.['@value']
        };
      });
      setOrganisations(organisationResults);
    } catch (error) {
      console.error(error);
    }
  };
  const getCollections = async () => {
    try {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/collections`);
      const collectionsResults = resp.data?.data?.map((x: any) => {
        return {
          key: x['collections:collectionsTitle'][0]?.['@value'], 
          value: x['collections:collectionsUniqueCode'][0]?.['@value'],
          collectionsIdentifierUniqueCode: x['collections:collectionsIdentifierUniqueCode'][0]?.['@value'],
          collection_id: x['o:id']
        };
      });      
      setCollections(collectionsResults);
    } catch (error) {
      console.error(error);
    }
  };
  const getTypeOptions = async () => {
    try {
      const response = await fetchTekmirioTypesOptions();
      const _tekmirioTypeOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));
      setTypeOptions(_tekmirioTypeOptions);
    } catch (error) {
      console.error(error);
    }
  };
  const getTypeFormat = async () => {
    try {
      const response = await fetchOAtypeFormat();
      const _tekmirioFormatOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));
      setFormatOptions(_tekmirioFormatOptions);
    } catch (error) {
      console.error(error);
    }
  };
  const getErga = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/ergo`);
    setErga(response.data?.data?.map((ergo: any) => {
      return {
        key: ergo['o:title'],
        value: ergo['o:id']
      };
    }));
  };

  const details = [
    [{
      name: 'Αναγνωριστικό Τεκμηρίου',
      value: omekaResponse?.documentIdentifier
    },
    {
      name: 'Μοναδικός Κωδικός',
      value: omekaResponse?.documentsUniqueCode
    }]
  ];

  const onCancelDocument = async () => {
    setOpenCancel(false);
    try {
      setOpenBackdrop(true);
      await HttpService.getAxiosClient().delete(`${process.env.REACT_APP_BACKEND_URL}/tekmirio/${omekaResponse?.id}`);
      setOmekaResponse({});
      enqueueSnackbar('Η Διαγραφή Τεκμηρίου πραγματοποιήθηκε επιτυχώς', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Η Διαγραφή Τεκμηρίου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    } finally {
      setOpenBackdrop(false);
    }
  };

  const fetchDocument = async (document_id: string) => {
    try {
      setIsLoadingDocument(true);
      const { document: document_object } = await getDocument(document_id);      
      setOmekaResponse(document_object);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingDocument(false);
    }
  };

  React.useEffect(() => {
    const document_id = localStorage.getItem('documentId');
    searchParams.delete('edit');
    searchParams.delete('preview');
    setSearchParams(searchParams);
    
    document_id 
      ? fetchDocument(document_id)
      : setOmekaResponse({});

    Promise.all([
      getOrganisations(),
      getCollections(),
      getTypeOptions(),
      getTypeFormat(),
      getErga()
    ]);
  }, []);

  // Set confirmation message in case someone wants to refresh or leave the page
  React.useEffect(() => {
    const unloadCallback = (event: any) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };
    
    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);

  return (
    <>
      <AsyncBackdropSubmit isLoading={openBackdrop}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <TitlePage 
        backButton={false}
        title={Object.prototype.hasOwnProperty.call(Object.fromEntries([...searchParams]), 'preview')
          ? 'Προεπισκόπηση Καταχώρισης Τεκμηρίου'
          : 'Εκκίνηση Καταχώρισης Τεκμηρίου'
        }/>
      {isLoadingDocument
        ? <FormSkeleton lines={6}/>
        : Object.keys(omekaResponse).length === 0 ? 
          <RegistrationStepComponent 
            initialValues={initialValuesDocument} 
            validation={newDocumentValidation} 
            step={
              createDocumentFields({organisations, collections, selectedForeas, setSelectedForeas})
            }
            onSubmit={onSubmit} /> 
          : !renderPreview
            ? <>
              <ContinueProcess
                renderOutsideReactRouter={true}
                label={'Συνέχεια επεξεργασίας στο OMEKA'}
                details={details}
                link={`https://repository.ekkomed.gr/omeka-s/admin/item/${omekaResponse.id}/edit`}/>
              <Divider sx={{width: '50%', display: 'flex', mx: 'auto'}}>Ή Επεξεργαστείτε Εδώ</Divider>
              <Formik
                enableReinitialize
                onSubmit={()=> undefined}
                initialValues={initialValuesEditDocument(omekaResponse)}
                validationSchema={editDocumentionValidation}
                validateOnBlur={false}
              >
                {formik =>
                  (<>
                    <Form>
                      <FormStepperBuilder 
                        formik={formik} 
                        form={insertDocumentFields(typeOptions, formatOptions, erga)}
                      />
                      <FormActionButtonLayout>
                        <Button 
                          variant='outlined' 
                          color='error'
                          onClick={() => setOpenCancel(true)}
                        > 
                          Ακύρωση Καταχώρισης               
                        </Button>
                        <Button 
                          variant='contained' 
                          disabled={
                            isSubmitEnabled(
                              formik?.errors,
                              Object.prototype.hasOwnProperty.call(Object.fromEntries([...searchParams]), 'edit') 
                                ? true
                                : formik?.dirty
                            )
                          }
                          onClick={() => {
                            setOmekaResponse({...formik.values} as any);
                            searchParams.set('preview', 'true');
                            searchParams.delete('edit');
                            setSearchParams(searchParams);
                            setRenderPreview(true);
                          }}
                        > 
                          Προεπισκόπηση Καταχώρισης
                        </Button>
                      </FormActionButtonLayout>
                    </Form>
                  </>)
                }
              </Formik>
              <DialogAction
                title='Ακύρωση Καταχώρισης Τεκμηρίου'
                content='Είστε σίγουρος ότι θέλετε να ακυρώσετε την καταχώριση'
                open={openCancel} 
                onAccept={() => {
                  setOpenCancel(false);
                  onCancelDocument();
                }}
                handleClose={() => setOpenCancel(false)}/>
            </> 
            : <PreviewTekmrio 
              onSubmit={onSubmitEdit}
              data={omekaResponse} 
              setRenderPreview={setRenderPreview}
              isLoading={isLoadingDocument}
              erga={erga}
            />
      }
    </>
  );
};

export default RegistrationDocument;